import type { FC } from "react";

import { AuthHeader, AuthHeaderWrapper } from "@shared/components";
import { useBreakpoints } from "@shared/hooks";
import type { PractitionerAdditionalAttributesType } from "@shared/types/PractitionerAdditionalAttributesType";
import { SignUpCarouselOrFooter, PractitionerSignUp } from "@unauthenticated/shared/components";
import type { PractitionerSignUpMutationData } from "@unauthenticated/shared/data/mutations/PractitionerSignUp.mutation";
import type { PractitionerType } from "@unauthenticated/shared/data/types";
import { PageContent, Page } from "@unauthenticated/signupSignin/components";

interface Props {
  practitionerTypes: PractitionerType[];
  additionalAttributes?: PractitionerAdditionalAttributesType;
  csuid: string;
  pageVersion: "prac_by_default_with_sso" | "prac_by_default";
}

const PractitionerSignUpPage: FC<Props> = ({
  practitionerTypes,
  additionalAttributes,
  csuid,
  pageVersion,
}) => {
  const { tablet } = useBreakpoints();

  const handleOnCompleted = (data: PractitionerSignUpMutationData) => {
    if (data.auth.practitionerSignUp.redirectPath) {
      window.location.assign(data.auth.practitionerSignUp.redirectPath);
    }
  };

  return (
    <Page data-e2e="sign-up-page">
      <PageContent>
        <AuthHeaderWrapper>
          <AuthHeader showFromWellevate showFromEmersonEcologics />
        </AuthHeaderWrapper>
        <PractitionerSignUp
          practitionerTypes={practitionerTypes}
          additionalAttributes={additionalAttributes}
          csuid={csuid}
          pageVersion={pageVersion}
          onCompleted={handleOnCompleted}
        />
      </PageContent>
      <SignUpCarouselOrFooter isWithinViewport={!tablet.greaterThan} />
    </Page>
  );
};

export { PractitionerSignUpPage };
